var _path, _circle, _circle2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPricetag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m509 186-26.852-35.802-14.93 104.512c-1.367 9.574-5.888 18.614-12.729 25.454L270.642 464.012c-16.036 16.038-37.382 24.871-60.104 24.871a85.78 85.78 0 0 1-19.894-2.34C200.424 501.833 217.541 512 237 512h220c30.327 0 55-24.673 55-55V195c0-3.245-1.053-6.403-3-9z",
    "data-original": "#000000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 309.533,
    cy: 234.203,
    r: 15,
    "data-original": "#000000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.827,
    cy: 234.203,
    r: 15,
    "data-original": "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m249.429 442.799 183.848-183.848a15 15 0 0 0 4.243-8.485l21.214-148.493a15 15 0 0 0-4.243-12.728l-31.82-31.82-42.426 42.427 10.607 10.607c5.858 5.857 5.858 15.355 0 21.213-2.929 2.929-6.768 4.394-10.606 4.394s-7.678-1.465-10.606-4.394l-42.427-42.427c-5.858-5.857-5.858-15.355 0-21.213 5.857-5.857 15.355-5.857 21.213 0l10.607 10.607 42.426-42.427-31.82-31.82A15.016 15.016 0 0 0 356.911.149L208.417 21.363a15 15 0 0 0-8.485 4.243L16.084 209.454c-21.445 21.444-21.445 56.338 0 77.782l155.563 155.563c10.722 10.723 24.807 16.083 38.891 16.083s28.169-5.36 38.891-16.083zm60.104-253.596c24.813 0 45 20.187 45 45s-20.187 45-45 45-45-20.187-45-45 20.187-45 45-45zm-169.706 90c-24.813 0-45-20.187-45-45s20.187-45 45-45 45 20.187 45 45-20.186 45-45 45zm49.5 76.07c-1.572 0-3.172-.249-4.745-.773-7.859-2.62-12.106-11.114-9.487-18.974l70.71-212.133c2.62-7.859 11.115-12.106 18.974-9.487 7.859 2.62 12.106 11.114 9.487 18.974l-70.71 212.133c-2.096 6.284-7.949 10.26-14.229 10.26z",
    "data-original": "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M454.489 25.606c5.858-5.857 5.858-15.355 0-21.213-5.857-5.857-15.355-5.857-21.213 0l-31.819 31.82 21.213 21.213z",
    "data-original": "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPricetag);
export default __webpack_public_path__ + "static/media/icon_pricetag.34c0baf17102918b6267a72cf878f333.svg";
export { ForwardRef as ReactComponent };